export class ImageLayers {
}
/**
 * Our custom replacement for the 'Editor Layer Index' (aka 'imagery.json')-file.
 * We only include layers that we have permission to use
 */
ImageLayers.layers = [
    {
        "id": "AIV_DHMV_II_HILL_25cm",
        "name": "AIV Digitaal Hoogtemodel Vlaanderen II, multidirectionale hillshade 0,25 m",
        "type": "wms",
        "template": "https://geoservices.informatievlaanderen.be/raadpleegdiensten/dhmv/wms?FORMAT=image/jpeg&VERSION=1.1.1&SERVICE=WMS&REQUEST=GetMap&LAYERS=DHMV_II_HILL_25cm&STYLES=&SRS={proj}&WIDTH={width}&HEIGHT={height}&BBOX={bbox}",
        "projection": "EPSG:3857",
        "endDate": "2015-01-01T00:00:00.000Z",
        "startDate": "2013-01-01T00:00:00.000Z",
        "polygon": [
            [
                [5.98494, 50.70723],
                [5.98494, 50.7672],
                [5.91079, 50.82275],
                [5.75561, 50.83533],
                [5.75423, 50.86264],
                [5.8332, 50.93323],
                [5.85517, 51.02661],
                [5.90941, 51.07754],
                [5.91216, 51.18225],
                [5.87851, 51.20807],
                [5.77414, 51.23689],
                [5.68419, 51.24075],
                [5.62308, 51.26998],
                [5.62308, 51.29789],
                [5.54, 51.34724],
                [5.4473, 51.34853],
                [5.39855, 51.32107],
                [5.31203, 51.32322],
                [5.26671, 51.36182],
                [5.19942, 51.37254],
                [5.18294, 51.39611],
                [5.15891, 51.4924],
                [5.08338, 51.53086],
                [5.03257, 51.53983],
                [4.95566, 51.50522],
                [4.90142, 51.50565],
                [4.83825, 51.54367],
                [4.77096, 51.55862],
                [4.7119, 51.54709],
                [4.64049, 51.49667],
                [4.6144, 51.4971],
                [4.56565, 51.53171],
                [4.48256, 51.53043],
                [4.42626, 51.52189],
                [4.3006, 51.46974],
                [4.29511, 51.42566],
                [4.18113, 51.42437],
                [4.13718, 51.39525],
                [4.13856, 51.35067],
                [4.05204, 51.30047],
                [3.93325, 51.27298],
                [3.86527, 51.27084],
                [3.86321, 51.29016],
                [3.76296, 51.32407],
                [3.59336, 51.35925],
                [3.47732, 51.33137],
                [3.42582, 51.39739],
                [3.23562, 51.35153],
                [3.226, 51.36568],
                [3.17794, 51.36182],
                [3.16009, 51.33223],
                [3.06258, 51.30219],
                [2.75084, 51.1702],
                [2.47001, 51.07452],
                [2.49267, 50.99378],
                [2.53112, 50.95573],
                [2.50915, 50.91159],
                [2.53043, 50.82145],
                [2.5991, 50.76416],
                [2.66501, 50.76459],
                [2.77007, 50.66677],
                [2.8971, 50.65894],
                [2.99186, 50.72549],
                [3.11339, 50.72636],
                [3.23699, 50.70592],
                [3.36265, 50.6585],
                [3.47114, 50.70201],
                [3.63936, 50.66721],
                [3.69842, 50.68156],
                [3.72794, 50.71245],
                [3.81858, 50.68418],
                [3.87488, 50.64152],
                [4.09255, 50.64283],
                [4.15023, 50.66329],
                [4.20653, 50.64413],
                [4.31365, 50.64283],
                [4.45235, 50.68766],
                [4.53475, 50.67808],
                [4.61303, 50.69549],
                [4.67689, 50.69592],
                [4.72701, 50.73201],
                [4.78057, 50.73201],
                [4.79979, 50.71288],
                [4.86228, 50.71288],
                [4.88563, 50.69549],
                [4.96116, 50.69549],
                [5.03119, 50.65763],
                [5.10741, 50.65023],
                [5.2008, 50.64892],
                [5.23581, 50.66546],
                [5.32508, 50.6659],
                [5.36696, 50.682],
                [5.42121, 50.66416],
                [5.52215, 50.6746],
                [5.6224, 50.72418],
                [5.67527, 50.69853],
                [5.73981, 50.69723],
                [5.77277, 50.67199],
                [5.8126, 50.66024],
                [5.90804, 50.65981],
                [5.98494, 50.70723]
            ]
        ],
        "terms_text": "© agentschap Informatie Vlaanderen",
        "icon": "https://osmlab.github.io/editor-layer-index/sources/europe/be/BE_GRB_Flanders_TMS.png"
    },
    {
        "id": "AIV_DHMV_II_SVF_25cm",
        "name": "AIV Digitaal Hoogtemodel Vlaanderen II, Skyview factor 0,25 m",
        "type": "wms",
        "template": "https://geoservices.informatievlaanderen.be/raadpleegdiensten/dhmv/wms?FORMAT=image/jpeg&VERSION=1.1.1&SERVICE=WMS&REQUEST=GetMap&LAYERS=DHMV_II_SVF_25cm&STYLES=&SRS={proj}&WIDTH={width}&HEIGHT={height}&BBOX={bbox}",
        "projection": "EPSG:3857",
        "endDate": "2015-01-01T00:00:00.000Z",
        "startDate": "2013-01-01T00:00:00.000Z",
        "polygon": [
            [
                [5.98494, 50.70723],
                [5.98494, 50.7672],
                [5.91079, 50.82275],
                [5.75561, 50.83533],
                [5.75423, 50.86264],
                [5.8332, 50.93323],
                [5.85517, 51.02661],
                [5.90941, 51.07754],
                [5.91216, 51.18225],
                [5.87851, 51.20807],
                [5.77414, 51.23689],
                [5.68419, 51.24075],
                [5.62308, 51.26998],
                [5.62308, 51.29789],
                [5.54, 51.34724],
                [5.4473, 51.34853],
                [5.39855, 51.32107],
                [5.31203, 51.32322],
                [5.26671, 51.36182],
                [5.19942, 51.37254],
                [5.18294, 51.39611],
                [5.15891, 51.4924],
                [5.08338, 51.53086],
                [5.03257, 51.53983],
                [4.95566, 51.50522],
                [4.90142, 51.50565],
                [4.83825, 51.54367],
                [4.77096, 51.55862],
                [4.7119, 51.54709],
                [4.64049, 51.49667],
                [4.6144, 51.4971],
                [4.56565, 51.53171],
                [4.48256, 51.53043],
                [4.42626, 51.52189],
                [4.3006, 51.46974],
                [4.29511, 51.42566],
                [4.18113, 51.42437],
                [4.13718, 51.39525],
                [4.13856, 51.35067],
                [4.05204, 51.30047],
                [3.93325, 51.27298],
                [3.86527, 51.27084],
                [3.86321, 51.29016],
                [3.76296, 51.32407],
                [3.59336, 51.35925],
                [3.47732, 51.33137],
                [3.42582, 51.39739],
                [3.23562, 51.35153],
                [3.226, 51.36568],
                [3.17794, 51.36182],
                [3.16009, 51.33223],
                [3.06258, 51.30219],
                [2.75084, 51.1702],
                [2.47001, 51.07452],
                [2.49267, 50.99378],
                [2.53112, 50.95573],
                [2.50915, 50.91159],
                [2.53043, 50.82145],
                [2.5991, 50.76416],
                [2.66501, 50.76459],
                [2.77007, 50.66677],
                [2.8971, 50.65894],
                [2.99186, 50.72549],
                [3.11339, 50.72636],
                [3.23699, 50.70592],
                [3.36265, 50.6585],
                [3.47114, 50.70201],
                [3.63936, 50.66721],
                [3.69842, 50.68156],
                [3.72794, 50.71245],
                [3.81858, 50.68418],
                [3.87488, 50.64152],
                [4.09255, 50.64283],
                [4.15023, 50.66329],
                [4.20653, 50.64413],
                [4.31365, 50.64283],
                [4.45235, 50.68766],
                [4.53475, 50.67808],
                [4.61303, 50.69549],
                [4.67689, 50.69592],
                [4.72701, 50.73201],
                [4.78057, 50.73201],
                [4.79979, 50.71288],
                [4.86228, 50.71288],
                [4.88563, 50.69549],
                [4.96116, 50.69549],
                [5.03119, 50.65763],
                [5.10741, 50.65023],
                [5.2008, 50.64892],
                [5.23581, 50.66546],
                [5.32508, 50.6659],
                [5.36696, 50.682],
                [5.42121, 50.66416],
                [5.52215, 50.6746],
                [5.6224, 50.72418],
                [5.67527, 50.69853],
                [5.73981, 50.69723],
                [5.77277, 50.67199],
                [5.8126, 50.66024],
                [5.90804, 50.65981],
                [5.98494, 50.70723]
            ]
        ],
        "terms_text": "© agentschap Informatie Vlaanderen",
        "icon": "https://osmlab.github.io/editor-layer-index/sources/europe/be/BE_GRB_Flanders_TMS.png"
    },
    {
        "id": "AGIV10cm",
        "name": "AIV Flanders 2013-2015 aerial imagery 10cm",
        "type": "wms",
        "template": "https://geoservices.informatievlaanderen.be/raadpleegdiensten/OGW/wms?FORMAT=image/jpeg&VERSION=1.1.1&SERVICE=WMS&REQUEST=GetMap&LAYERS=OGWRGB13_15VL&STYLES=&SRS={proj}&WIDTH={width}&HEIGHT={height}&BBOX={bbox}",
        "projection": "EPSG:3857",
        "endDate": "2015-01-01T00:00:00.000Z",
        "startDate": "2013-01-01T00:00:00.000Z",
        "polygon": [
            [
                [5.98494, 50.70723],
                [5.98494, 50.7672],
                [5.91079, 50.82275],
                [5.75561, 50.83533],
                [5.75423, 50.86264],
                [5.8332, 50.93323],
                [5.85517, 51.02661],
                [5.90941, 51.07754],
                [5.91216, 51.18225],
                [5.87851, 51.20807],
                [5.77414, 51.23689],
                [5.68419, 51.24075],
                [5.62308, 51.26998],
                [5.62308, 51.29789],
                [5.54, 51.34724],
                [5.4473, 51.34853],
                [5.39855, 51.32107],
                [5.31203, 51.32322],
                [5.26671, 51.36182],
                [5.19942, 51.37254],
                [5.18294, 51.39611],
                [5.15891, 51.4924],
                [5.08338, 51.53086],
                [5.03257, 51.53983],
                [4.95566, 51.50522],
                [4.90142, 51.50565],
                [4.83825, 51.54367],
                [4.77096, 51.55862],
                [4.7119, 51.54709],
                [4.64049, 51.49667],
                [4.6144, 51.4971],
                [4.56565, 51.53171],
                [4.48256, 51.53043],
                [4.42626, 51.52189],
                [4.3006, 51.46974],
                [4.29511, 51.42566],
                [4.18113, 51.42437],
                [4.13718, 51.39525],
                [4.13856, 51.35067],
                [4.05204, 51.30047],
                [3.93325, 51.27298],
                [3.86527, 51.27084],
                [3.86321, 51.29016],
                [3.76296, 51.32407],
                [3.59336, 51.35925],
                [3.47732, 51.33137],
                [3.42582, 51.39739],
                [3.23562, 51.35153],
                [3.226, 51.36568],
                [3.17794, 51.36182],
                [3.16009, 51.33223],
                [3.06258, 51.30219],
                [2.75084, 51.1702],
                [2.47001, 51.07452],
                [2.49267, 50.99378],
                [2.53112, 50.95573],
                [2.50915, 50.91159],
                [2.53043, 50.82145],
                [2.5991, 50.76416],
                [2.66501, 50.76459],
                [2.77007, 50.66677],
                [2.8971, 50.65894],
                [2.99186, 50.72549],
                [3.11339, 50.72636],
                [3.23699, 50.70592],
                [3.36265, 50.6585],
                [3.47114, 50.70201],
                [3.63936, 50.66721],
                [3.69842, 50.68156],
                [3.72794, 50.71245],
                [3.81858, 50.68418],
                [3.87488, 50.64152],
                [4.09255, 50.64283],
                [4.15023, 50.66329],
                [4.20653, 50.64413],
                [4.31365, 50.64283],
                [4.45235, 50.68766],
                [4.53475, 50.67808],
                [4.61303, 50.69549],
                [4.67689, 50.69592],
                [4.72701, 50.73201],
                [4.78057, 50.73201],
                [4.79979, 50.71288],
                [4.86228, 50.71288],
                [4.88563, 50.69549],
                [4.96116, 50.69549],
                [5.03119, 50.65763],
                [5.10741, 50.65023],
                [5.2008, 50.64892],
                [5.23581, 50.66546],
                [5.32508, 50.6659],
                [5.36696, 50.682],
                [5.42121, 50.66416],
                [5.52215, 50.6746],
                [5.6224, 50.72418],
                [5.67527, 50.69853],
                [5.73981, 50.69723],
                [5.77277, 50.67199],
                [5.8126, 50.66024],
                [5.90804, 50.65981],
                [5.98494, 50.70723]
            ]
        ],
        "terms_text": "© agentschap Informatie Vlaanderen",
        "icon": "https://osmlab.github.io/editor-layer-index/sources/europe/be/BE_GRB_Flanders_TMS.png"
    },
    {
        "id": "AGIVFlandersGRB",
        "name": "AIV Flanders GRB",
        "type": "tms",
        "template": "https://geo.api.vlaanderen.be/GRB/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=grb_bsk&STYLE=&FORMAT=image/png&tileMatrixSet=GoogleMapsVL&tileMatrix={z}&tileRow={y}&tileCol={x}",
        "zoomExtent": [0, 21],
        "polygon": [
            [
                [4.40434, 50.78177],
                [4.45538, 50.79328],
                [4.40268, 50.8961],
                [4.331, 50.90094],
                [4.27142, 50.82002],
                [4.30648, 50.81244],
                [4.36348, 50.77251],
                [4.40434, 50.78177],
                [4.43104, 50.73831],
                [4.31859, 50.72022],
                [4.29031, 50.69402],
                [4.14853, 50.72834],
                [3.95877, 50.68947],
                [3.9097, 50.69245],
                [3.89113, 50.74333],
                [3.77568, 50.74789],
                [3.75857, 50.78045],
                [3.67752, 50.77062],
                [3.64047, 50.72242],
                [3.54139, 50.73377],
                [3.54062, 50.76307],
                [3.46005, 50.76556],
                [3.3522, 50.70614],
                [3.30562, 50.75466],
                [3.17839, 50.75609],
                [3.15329, 50.78564],
                [3.02008, 50.77312],
                [2.99943, 50.81035],
                [2.91648, 50.75356],
                [2.85476, 50.75745],
                [2.86521, 50.70565],
                [2.78473, 50.7369],
                [2.713, 50.81534],
                [2.63518, 50.8129],
                [2.59909, 50.85306],
                [2.59031, 50.91893],
                [2.63262, 50.94575],
                [2.57372, 51.00842],
                [2.54165, 51.09345],
                [3.15582, 51.32714],
                [3.18307, 51.37128],
                [3.23443, 51.34669],
                [3.36356, 51.37228],
                [3.38101, 51.27446],
                [3.44201, 51.24313],
                [3.52759, 51.24604],
                [3.51511, 51.28753],
                [3.58984, 51.30577],
                [3.7783, 51.26235],
                [3.79088, 51.21429],
                [3.92412, 51.21938],
                [4.16613, 51.2929],
                [4.26163, 51.37647],
                [4.42065, 51.36473],
                [4.39108, 51.45149],
                [4.54747, 51.48571],
                [4.53541, 51.42303],
                [4.64953, 51.42758],
                [4.76359, 51.5088],
                [4.84188, 51.48074],
                [4.8383, 51.42174],
                [4.89366, 51.41698],
                [4.92785, 51.39544],
                [5.02894, 51.48789],
                [5.08018, 51.46948],
                [5.10202, 51.42892],
                [5.07117, 51.3935],
                [5.13109, 51.35137],
                [5.13448, 51.31547],
                [5.20031, 51.32172],
                [5.24189, 51.30534],
                [5.23036, 51.26436],
                [5.34828, 51.27492],
                [5.41741, 51.26229],
                [5.4863, 51.30197],
                [5.5556, 51.26986],
                [5.56045, 51.22233],
                [5.76027, 51.18505],
                [5.85578, 51.14463],
                [5.75909, 51.03588],
                [5.72665, 50.91307],
                [5.64522, 50.8372],
                [5.68732, 50.804],
                [5.47863, 50.72352],
                [5.41196, 50.72368],
                [5.38908, 50.74775],
                [5.30912, 50.71802],
                [5.16984, 50.72257],
                [5.16508, 50.6957],
                [5.05642, 50.71567],
                [5.00339, 50.76594],
                [4.92545, 50.74275],
                [4.90869, 50.76968],
                [4.83106, 50.77028],
                [4.76014, 50.80544],
                [4.64309, 50.79755],
                [4.65486, 50.7552],
                [4.62021, 50.74348],
                [4.59727, 50.76359],
                [4.52399, 50.72724],
                [4.49455, 50.75679],
                [4.43104, 50.73831],
                [4.40434, 50.78177]
            ],
            [
                [5.67393, 50.75373],
                [5.88438, 50.70114],
                [5.94172, 50.76524],
                [5.76662, 50.78761],
                [5.67393, 50.75373]
            ],
            [
                [4.91171, 51.43492],
                [4.93711, 51.42614],
                [4.95891, 51.45471],
                [4.92801, 51.46049],
                [4.91171, 51.43492]
            ]
        ],
        "terms_text": "© agentschap Informatie Vlaanderen",
        "icon": "https://osmlab.github.io/editor-layer-index/sources/europe/be/BE_GRB_Flanders_TMS.png"
    },
    {
        "id": "AGIV",
        "name": "AIV Flanders most recent aerial imagery",
        "type": "tms",
        "template": "https://geo.api.vlaanderen.be/GRB/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=grb_bsk&STYLE=&FORMAT=image/png&tileMatrixSet=GoogleMapsVL&tileMatrix={z}&tileRow={y}&tileCol={x}",
        "zoomExtent": [0, 21],
        "polygon": [
            [
                [4.7737, 50.79368],
                [4.8379, 50.75916],
                [4.92511, 50.73483],
                [4.98862, 50.76264],
                [5.036, 50.73527],
                [5.0645, 50.69875],
                [5.1644, 50.69005],
                [5.19393, 50.71179],
                [5.3086, 50.71245],
                [5.36422, 50.74396],
                [5.43391, 50.70766],
                [5.54378, 50.74396],
                [5.61141, 50.73527],
                [5.71166, 50.73505],
                [5.77105, 50.74092],
                [5.81946, 50.70484],
                [5.89568, 50.70614],
                [5.9204, 50.72831],
                [5.91971, 50.74504],
                [5.89843, 50.77675],
                [5.81569, 50.76351],
                [5.77517, 50.79216],
                [5.69552, 50.79737],
                [5.69072, 50.82319],
                [5.66325, 50.82904],
                [5.65467, 50.86481],
                [5.72368, 50.9012],
                [5.77174, 50.95443],
                [5.75114, 50.97368],
                [5.78273, 51.00048],
                [5.78032, 51.0523],
                [5.80848, 51.05338],
                [5.80951, 51.07668],
                [5.84315, 51.09372],
                [5.84418, 51.1101],
                [5.82599, 51.11851],
                [5.86959, 51.14953],
                [5.8277, 51.17365],
                [5.792, 51.16891],
                [5.7738, 51.19344],
                [5.666, 51.1928],
                [5.64059, 51.21065],
                [5.5709, 51.22829],
                [5.56231, 51.27535],
                [5.49811, 51.30605],
                [5.47099, 51.30219],
                [5.45794, 51.2893],
                [5.43048, 51.28823],
                [5.41434, 51.27363],
                [5.36593, 51.282],
                [5.33641, 51.28265],
                [5.32577, 51.26718],
                [5.24337, 51.27406],
                [5.24989, 51.31335],
                [5.20972, 51.32794],
                [5.14174, 51.31914],
                [5.14209, 51.35367],
                [5.08647, 51.39482],
                [5.11565, 51.43615],
                [5.08853, 51.47508],
                [5.05214, 51.47636],
                [5.04561, 51.4939],
                [5.02364, 51.4939],
                [5.01609, 51.48663],
                [4.82966, 51.48663],
                [4.83001, 51.50009],
                [4.76855, 51.51099],
                [4.74727, 51.50394],
                [4.658, 51.4492],
                [4.65663, 51.43144],
                [4.53956, 51.43379],
                [4.55466, 51.48171],
                [4.5296, 51.48748],
                [4.46368, 51.48235],
                [4.37167, 51.45562],
                [4.37751, 51.40553],
                [4.4139, 51.37511],
                [4.39776, 51.36118],
                [4.34798, 51.36675],
                [4.34627, 51.38497],
                [4.20344, 51.38111],
                [4.2213, 51.3511],
                [4.15641, 51.29832],
                [4.05101, 51.25193],
                [4.00638, 51.25279],
                [3.95144, 51.22205],
                [3.88484, 51.22936],
                [3.81926, 51.21797],
                [3.80038, 51.22872],
                [3.80107, 51.26074],
                [3.74442, 51.28007],
                [3.63593, 51.29746],
                [3.58615, 51.31378],
                [3.5065, 51.28308],
                [3.51371, 51.25021],
                [3.43921, 51.25064],
                [3.39766, 51.27513],
                [3.37329, 51.31678],
                [3.39114, 51.34274],
                [3.3623, 51.37961],
                [3.24283, 51.35474],
                [3.20266, 51.37039],
                [3.15631, 51.35196],
                [3.14223, 51.33051],
                [2.53318, 51.09092],
                [2.56476, 50.9968],
                [2.61832, 50.9527],
                [2.57781, 50.91852],
                [2.5936, 50.88431],
                [2.58948, 50.85051],
                [2.6245, 50.80757],
                [2.71033, 50.8054],
                [2.78449, 50.71853],
                [2.87375, 50.69983],
                [2.86483, 50.74765],
                [2.92525, 50.75156],
                [2.97263, 50.77024],
                [2.97332, 50.79889],
                [3.00078, 50.79759],
                [3.01383, 50.76676],
                [3.09863, 50.76611],
                [3.13537, 50.78196],
                [3.16832, 50.75004],
                [3.30428, 50.74613],
                [3.31561, 50.71484],
                [3.3678, 50.70179],
                [3.44848, 50.75091],
                [3.53293, 50.75156],
                [3.53328, 50.72549],
                [3.63902, 50.7131],
                [3.69086, 50.7672],
                [3.75163, 50.76177],
                [3.7712, 50.73874],
                [3.87729, 50.73983],
                [3.87969, 50.70418],
                [3.9202, 50.68352],
                [3.99951, 50.682],
                [4.06749, 50.68961],
                [4.16018, 50.72049],
                [4.17632, 50.70331],
                [4.24739, 50.68222],
                [4.31708, 50.69418],
                [4.31846, 50.70962],
                [4.38403, 50.71027],
                [4.38437, 50.72353],
                [4.47226, 50.74743],
                [4.52617, 50.71853],
                [4.55226, 50.73766],
                [4.64908, 50.73722],
                [4.6532, 50.78717],
                [4.72426, 50.78218],
                [4.73731, 50.79585],
                [4.7737, 50.79368]
            ]
        ],
        "terms_text": "© agentschap Informatie Vlaanderen",
        "best": true,
        "icon": "https://osmlab.github.io/editor-layer-index/sources/europe/be/BE_GRB_Flanders_TMS.png"
    },
    {
        "id": "MAPNIK",
        "name": "OpenStreetMap (Standard)",
        "type": "tms",
        "template": "https://{switch:a,b,c}.tile.openstreetmap.org/{zoom}/{x}/{y}.png",
        "zoomExtent": [0, 19],
        "terms_url": "https://www.openstreetmap.org",
        "terms_text": "© OpenStreetMap contributors, CC-BY-SA",
        "default": true,
        "description": "The default OpenStreetMap layer.",
        "icon": "https://osmlab.github.io/editor-layer-index/sources/world/OpenStreetMap-GPS.png"
    },
    {
        "id": "osm-gps",
        "name": "OpenStreetMap GPS traces",
        "type": "tms",
        "template": "https://{switch:a,b,c}.gps-tile.openstreetmap.org/lines/{zoom}/{x}/{y}.png",
        "zoomExtent": [0, 20],
        "terms_url": "https://www.openstreetmap.org/copyright",
        "terms_text": "© OpenStreetMap contributors",
        "terms_html": "<span style='display: inline-block; padding: 0 8px; background-color: rgba(0,0,0,0.5);'><span style='color: #eee;'>GPS Direction:</span> <span style='font-size: 15px; padding-left: 2px; font-weight: bold;'> <span style='color: #0ee;'>&larr;</span> <span style='color: #96f;'>&darr;</span> <span style='color: #6e0;'>&uarr;</span> <span style='color: #f63;'>&rarr;</span> </span></span> © <a href='https://www.openstreetmap.org/copyright'>OpenStreetMap contributors</a>.",
        "description": "Public GPS traces uploaded to OpenStreetMap.",
        "icon": "https://osmlab.github.io/editor-layer-index/sources/world/OpenStreetMap-GPS.png",
        "overlay": true
    },
    {
        "id": "URBIS2009",
        "name": "URBIS 2009 aerial imagery",
        "type": "wms",
        "template": "https://geoservices-urbis.irisnet.be/geoserver/ows?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetMap&FORMAT=image/png&TRANSPARENT=true&LAYERS=Urbis:Ortho2009&WIDTH={width}&HEIGHT={height}&CRS={proj}&STYLES=&BBOX={bbox}",
        "projection": "EPSG:3857",
        "endDate": "2009-01-01T00:00:00.000Z",
        "startDate": "2009-01-01T00:00:00.000Z",
        "polygon": [
            [
                [4.37973, 50.76382],
                [4.38917, 50.76377],
                [4.43028, 50.77517],
                [4.435, 50.775],
                [4.46427, 50.78645],
                [4.4817, 50.79134],
                [4.48238, 50.79617],
                [4.45921, 50.80626],
                [4.45947, 50.81661],
                [4.47972, 50.82036],
                [4.46959, 50.83537],
                [4.46899, 50.84573],
                [4.46238, 50.85396],
                [4.44968, 50.85591],
                [4.44599, 50.85992],
                [4.4253, 50.86615],
                [4.43183, 50.87628],
                [4.44007, 50.87845],
                [4.43106, 50.89014],
                [4.43595, 50.89502],
                [4.4296, 50.90103],
                [4.41655, 50.90757],
                [4.41543, 50.91342],
                [4.39578, 50.91407],
                [4.38462, 50.91093],
                [4.38119, 50.90319],
                [4.3726, 50.90032],
                [4.36213, 50.9033],
                [4.34857, 50.90341],
                [4.34025, 50.90411],
                [4.32892, 50.90249],
                [4.31647, 50.89605],
                [4.30634, 50.89274],
                [4.29004, 50.88982],
                [4.29149, 50.88495],
                [4.29553, 50.88262],
                [4.29561, 50.88094],
                [4.28274, 50.87227],
                [4.27699, 50.86713],
                [4.27802, 50.85911],
                [4.28042, 50.85721],
                [4.28094, 50.84215],
                [4.27193, 50.84036],
                [4.25467, 50.83695],
                [4.25107, 50.83288],
                [4.25227, 50.82697],
                [4.24343, 50.82182],
                [4.24403, 50.81548],
                [4.25519, 50.8151],
                [4.25802, 50.80935],
                [4.27218, 50.81011],
                [4.27579, 50.80696],
                [4.2854, 50.80506],
                [4.28901, 50.80691],
                [4.29802, 50.80593],
                [4.30282, 50.79709],
                [4.31458, 50.79454],
                [4.31621, 50.78624],
                [4.32952, 50.77381],
                [4.34205, 50.77164],
                [4.34522, 50.77337],
                [4.37853, 50.76811],
                [4.37973, 50.76382]
            ]
        ],
        "terms_text": "Realized by means of Brussels UrbIS®© - Distribution & Copyright CIRB",
        "icon": "https://osmlab.github.io/editor-layer-index/sources/europe/be/URBIS2015aerialimagery.png"
    },
    {
        "id": "URBIS2012",
        "name": "URBIS 2012 aerial imagery",
        "type": "wms",
        "template": "https://geoservices-urbis.irisnet.be/geoserver/ows?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetMap&FORMAT=image/png&TRANSPARENT=true&LAYERS=Urbis:Ortho2012&WIDTH={width}&HEIGHT={height}&CRS={proj}&STYLES=&BBOX={bbox}",
        "projection": "EPSG:3857",
        "endDate": "2012-01-01T00:00:00.000Z",
        "startDate": "2012-01-01T00:00:00.000Z",
        "polygon": [
            [
                [4.37973, 50.76382],
                [4.38917, 50.76377],
                [4.43028, 50.77517],
                [4.435, 50.775],
                [4.46427, 50.78645],
                [4.4817, 50.79134],
                [4.48238, 50.79617],
                [4.45921, 50.80626],
                [4.45947, 50.81661],
                [4.47972, 50.82036],
                [4.46959, 50.83537],
                [4.46899, 50.84573],
                [4.46238, 50.85396],
                [4.44968, 50.85591],
                [4.44599, 50.85992],
                [4.4253, 50.86615],
                [4.43183, 50.87628],
                [4.44007, 50.87845],
                [4.43106, 50.89014],
                [4.43595, 50.89502],
                [4.4296, 50.90103],
                [4.41655, 50.90757],
                [4.41543, 50.91342],
                [4.39578, 50.91407],
                [4.38462, 50.91093],
                [4.38119, 50.90319],
                [4.3726, 50.90032],
                [4.36213, 50.9033],
                [4.34857, 50.90341],
                [4.34025, 50.90411],
                [4.32892, 50.90249],
                [4.31647, 50.89605],
                [4.30634, 50.89274],
                [4.29004, 50.88982],
                [4.29149, 50.88495],
                [4.29553, 50.88262],
                [4.29561, 50.88094],
                [4.28274, 50.87227],
                [4.27699, 50.86713],
                [4.27802, 50.85911],
                [4.28042, 50.85721],
                [4.28094, 50.84215],
                [4.27193, 50.84036],
                [4.25467, 50.83695],
                [4.25107, 50.83288],
                [4.25227, 50.82697],
                [4.24343, 50.82182],
                [4.24403, 50.81548],
                [4.25519, 50.8151],
                [4.25802, 50.80935],
                [4.27218, 50.81011],
                [4.27579, 50.80696],
                [4.2854, 50.80506],
                [4.28901, 50.80691],
                [4.29802, 50.80593],
                [4.30282, 50.79709],
                [4.31458, 50.79454],
                [4.31621, 50.78624],
                [4.32952, 50.77381],
                [4.34205, 50.77164],
                [4.34522, 50.77337],
                [4.37853, 50.76811],
                [4.37973, 50.76382]
            ]
        ],
        "terms_text": "Realized by means of Brussels UrbIS®© - Distribution & Copyright CIRB",
        "icon": "https://osmlab.github.io/editor-layer-index/sources/europe/be/URBIS2015aerialimagery.png"
    },
    {
        "id": "URBIS2014",
        "name": "URBIS 2014 aerial imagery",
        "type": "wms",
        "template": "https://geoservices-urbis.irisnet.be/geoserver/ows?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetMap&FORMAT=image/png&TRANSPARENT=true&LAYERS=Urbis:Ortho2014&WIDTH={width}&HEIGHT={height}&CRS={proj}&STYLES=&BBOX={bbox}",
        "projection": "EPSG:3857",
        "endDate": "2014-01-01T00:00:00.000Z",
        "startDate": "2014-01-01T00:00:00.000Z",
        "polygon": [
            [
                [4.4001, 50.76373],
                [4.43093, 50.77254],
                [4.43586, 50.77237],
                [4.46549, 50.78373],
                [4.48189, 50.78835],
                [4.48269, 50.79849],
                [4.46363, 50.80686],
                [4.46407, 50.81546],
                [4.48204, 50.81699],
                [4.48103, 50.82343],
                [4.47465, 50.83505],
                [4.47403, 50.84587],
                [4.46712, 50.85447],
                [4.45257, 50.85797],
                [4.45017, 50.86151],
                [4.42968, 50.86764],
                [4.43423, 50.87384],
                [4.44147, 50.87513],
                [4.44381, 50.88004],
                [4.43534, 50.88977],
                [4.43968, 50.89475],
                [4.43287, 50.90363],
                [4.42096, 50.90917],
                [4.42023, 50.91387],
                [4.38315, 50.91381],
                [4.37879, 50.90637],
                [4.37334, 50.90289],
                [4.36241, 50.906],
                [4.34824, 50.90611],
                [4.33955, 50.90685],
                [4.32771, 50.90515],
                [4.31471, 50.89842],
                [4.30413, 50.89498],
                [4.2871, 50.89192],
                [4.28725, 50.88532],
                [4.29293, 50.88265],
                [4.27948, 50.8736],
                [4.27347, 50.86822],
                [4.27364, 50.85871],
                [4.27688, 50.85575],
                [4.27644, 50.84376],
                [4.26664, 50.8405],
                [4.25488, 50.83992],
                [4.24755, 50.83453],
                [4.24799, 50.82866],
                [4.24357, 50.82599],
                [4.24376, 50.81356],
                [4.25233, 50.81268],
                [4.25649, 50.80711],
                [4.27025, 50.8073],
                [4.27222, 50.80537],
                [4.28414, 50.80241],
                [4.28885, 50.80434],
                [4.29544, 50.8043],
                [4.30046, 50.79506],
                [4.31076, 50.79299],
                [4.31444, 50.78372],
                [4.32628, 50.77221],
                [4.34194, 50.76891],
                [4.34474, 50.77029],
                [4.37535, 50.76577],
                [4.3755, 50.76381],
                [4.4001, 50.76373]
            ]
        ],
        "terms_text": "Realized by means of Brussels UrbIS®© - Distribution & Copyright CIRB",
        "icon": "https://osmlab.github.io/editor-layer-index/sources/europe/be/URBIS2015aerialimagery.png"
    },
    {
        "id": "URBIS2015",
        "name": "URBIS 2015 aerial imagery",
        "type": "wms",
        "template": "https://geoservices-urbis.irisnet.be/geoserver/ows?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetMap&FORMAT=image/png&TRANSPARENT=true&LAYERS=Urbis:Ortho2015&WIDTH={width}&HEIGHT={height}&CRS={proj}&STYLES=&BBOX={bbox}",
        "projection": "EPSG:3857",
        "endDate": "2015-01-01T00:00:00.000Z",
        "startDate": "2015-01-01T00:00:00.000Z",
        "polygon": [
            [
                [4.37973, 50.76382],
                [4.38917, 50.76377],
                [4.43028, 50.77517],
                [4.435, 50.775],
                [4.46427, 50.78645],
                [4.4817, 50.79134],
                [4.48238, 50.79617],
                [4.45921, 50.80626],
                [4.45947, 50.81661],
                [4.47972, 50.82036],
                [4.46959, 50.83537],
                [4.46899, 50.84573],
                [4.46238, 50.85396],
                [4.44968, 50.85591],
                [4.44599, 50.85992],
                [4.4253, 50.86615],
                [4.43183, 50.87628],
                [4.44007, 50.87845],
                [4.43106, 50.89014],
                [4.43595, 50.89502],
                [4.4296, 50.90103],
                [4.41655, 50.90757],
                [4.41543, 50.91342],
                [4.39578, 50.91407],
                [4.38462, 50.91093],
                [4.38119, 50.90319],
                [4.3726, 50.90032],
                [4.36213, 50.9033],
                [4.34857, 50.90341],
                [4.34025, 50.90411],
                [4.32892, 50.90249],
                [4.31647, 50.89605],
                [4.30634, 50.89274],
                [4.29004, 50.88982],
                [4.29149, 50.88495],
                [4.29553, 50.88262],
                [4.29561, 50.88094],
                [4.28274, 50.87227],
                [4.27699, 50.86713],
                [4.27802, 50.85911],
                [4.28042, 50.85721],
                [4.28094, 50.84215],
                [4.27193, 50.84036],
                [4.25467, 50.83695],
                [4.25107, 50.83288],
                [4.25227, 50.82697],
                [4.24343, 50.82182],
                [4.24403, 50.81548],
                [4.25519, 50.8151],
                [4.25802, 50.80935],
                [4.27218, 50.81011],
                [4.27579, 50.80696],
                [4.2854, 50.80506],
                [4.28901, 50.80691],
                [4.29802, 50.80593],
                [4.30282, 50.79709],
                [4.31458, 50.79454],
                [4.31621, 50.78624],
                [4.32952, 50.77381],
                [4.34205, 50.77164],
                [4.34522, 50.77337],
                [4.37853, 50.76811],
                [4.37973, 50.76382]
            ]
        ],
        "terms_text": "Realized by means of Brussels UrbIS®© - Distribution & Copyright CIRB",
        "icon": "https://osmlab.github.io/editor-layer-index/sources/europe/be/URBIS2015aerialimagery.png"
    },
    {
        "id": "UrbISOrtho2016",
        "name": "UrbIS-Ortho 2016",
        "type": "wms",
        "template": "https://geoservices-urbis.irisnet.be/geoserver/ows?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetMap&FORMAT=image/png&TRANSPARENT=true&LAYERS=Urbis:Ortho2016&WIDTH={width}&HEIGHT={height}&CRS={proj}&STYLES=&BBOX={bbox}",
        "projection": "EPSG:3857",
        "endDate": "2016-01-01T00:00:00.000Z",
        "startDate": "2016-01-01T00:00:00.000Z",
        "polygon": [
            [
                [4.37973, 50.76382],
                [4.38917, 50.76377],
                [4.43028, 50.77517],
                [4.435, 50.775],
                [4.46427, 50.78645],
                [4.4817, 50.79134],
                [4.48238, 50.79617],
                [4.45921, 50.80626],
                [4.45947, 50.81661],
                [4.47972, 50.82036],
                [4.46959, 50.83537],
                [4.46899, 50.84573],
                [4.46238, 50.85396],
                [4.44968, 50.85591],
                [4.44599, 50.85992],
                [4.4253, 50.86615],
                [4.43183, 50.87628],
                [4.44007, 50.87845],
                [4.43106, 50.89014],
                [4.43595, 50.89502],
                [4.4296, 50.90103],
                [4.41655, 50.90757],
                [4.41543, 50.91342],
                [4.39578, 50.91407],
                [4.38462, 50.91093],
                [4.38119, 50.90319],
                [4.3726, 50.90032],
                [4.36213, 50.9033],
                [4.34857, 50.90341],
                [4.34025, 50.90411],
                [4.32892, 50.90249],
                [4.31647, 50.89605],
                [4.30634, 50.89274],
                [4.29004, 50.88982],
                [4.29149, 50.88495],
                [4.29553, 50.88262],
                [4.29561, 50.88094],
                [4.28274, 50.87227],
                [4.27699, 50.86713],
                [4.27802, 50.85911],
                [4.28042, 50.85721],
                [4.28094, 50.84215],
                [4.27193, 50.84036],
                [4.25467, 50.83695],
                [4.25107, 50.83288],
                [4.25227, 50.82697],
                [4.24343, 50.82182],
                [4.24403, 50.81548],
                [4.25519, 50.8151],
                [4.25802, 50.80935],
                [4.27218, 50.81011],
                [4.27579, 50.80696],
                [4.2854, 50.80506],
                [4.28901, 50.80691],
                [4.29802, 50.80593],
                [4.30282, 50.79709],
                [4.31458, 50.79454],
                [4.31621, 50.78624],
                [4.32952, 50.77381],
                [4.34205, 50.77164],
                [4.34522, 50.77337],
                [4.37853, 50.76811],
                [4.37973, 50.76382]
            ]
        ],
        "terms_text": "Realized by means of Brussels UrbIS®© - Distribution & Copyright CIRB",
        "icon": "https://osmlab.github.io/editor-layer-index/sources/europe/be/URBIS2015aerialimagery.png"
    },
    {
        "id": "UrbISOrtho2017",
        "name": "UrbIS-Ortho 2017",
        "type": "wms",
        "template": "https://geoservices-urbis.irisnet.be/geoserver/ows?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetMap&FORMAT=image/png&TRANSPARENT=true&LAYERS=Urbis:Ortho2017&WIDTH={width}&HEIGHT={height}&CRS={proj}&STYLES=&BBOX={bbox}",
        "projection": "EPSG:3857",
        "endDate": "2017-01-01T00:00:00.000Z",
        "startDate": "2017-01-01T00:00:00.000Z",
        "polygon": [
            [
                [4.37973, 50.76382],
                [4.38917, 50.76377],
                [4.43028, 50.77517],
                [4.435, 50.775],
                [4.46427, 50.78645],
                [4.4817, 50.79134],
                [4.48238, 50.79617],
                [4.45921, 50.80626],
                [4.45947, 50.81661],
                [4.47972, 50.82036],
                [4.46959, 50.83537],
                [4.46899, 50.84573],
                [4.46238, 50.85396],
                [4.44968, 50.85591],
                [4.44599, 50.85992],
                [4.4253, 50.86615],
                [4.43183, 50.87628],
                [4.44007, 50.87845],
                [4.43106, 50.89014],
                [4.43595, 50.89502],
                [4.4296, 50.90103],
                [4.41655, 50.90757],
                [4.41543, 50.91342],
                [4.39578, 50.91407],
                [4.38462, 50.91093],
                [4.38119, 50.90319],
                [4.3726, 50.90032],
                [4.36213, 50.9033],
                [4.34857, 50.90341],
                [4.34025, 50.90411],
                [4.32892, 50.90249],
                [4.31647, 50.89605],
                [4.30634, 50.89274],
                [4.29004, 50.88982],
                [4.29149, 50.88495],
                [4.29553, 50.88262],
                [4.29561, 50.88094],
                [4.28274, 50.87227],
                [4.27699, 50.86713],
                [4.27802, 50.85911],
                [4.28042, 50.85721],
                [4.28094, 50.84215],
                [4.27193, 50.84036],
                [4.25467, 50.83695],
                [4.25107, 50.83288],
                [4.25227, 50.82697],
                [4.24343, 50.82182],
                [4.24403, 50.81548],
                [4.25519, 50.8151],
                [4.25802, 50.80935],
                [4.27218, 50.81011],
                [4.27579, 50.80696],
                [4.2854, 50.80506],
                [4.28901, 50.80691],
                [4.29802, 50.80593],
                [4.30282, 50.79709],
                [4.31458, 50.79454],
                [4.31621, 50.78624],
                [4.32952, 50.77381],
                [4.34205, 50.77164],
                [4.34522, 50.77337],
                [4.37853, 50.76811],
                [4.37973, 50.76382]
            ]
        ],
        "terms_text": "Realized by means of Brussels UrbIS®© - Distribution & Copyright CIRB",
        "icon": "https://osmlab.github.io/editor-layer-index/sources/europe/be/URBIS2015aerialimagery.png"
    },
    {
        "id": "UrbISOrtho2018",
        "name": "UrbIS-Ortho 2018",
        "type": "wms",
        "template": "https://geoservices-urbis.irisnet.be/geoserver/ows?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetMap&FORMAT=image/png&TRANSPARENT=true&LAYERS=Urbis:Ortho2018&WIDTH={width}&HEIGHT={height}&CRS={proj}&STYLES=&BBOX={bbox}",
        "projection": "EPSG:3857",
        "endDate": "2018-01-01T00:00:00.000Z",
        "startDate": "2018-01-01T00:00:00.000Z",
        "polygon": [
            [
                [4.37973, 50.76382],
                [4.38917, 50.76377],
                [4.43028, 50.77517],
                [4.435, 50.775],
                [4.46427, 50.78645],
                [4.4817, 50.79134],
                [4.48238, 50.79617],
                [4.45921, 50.80626],
                [4.45947, 50.81661],
                [4.47972, 50.82036],
                [4.46959, 50.83537],
                [4.46899, 50.84573],
                [4.46238, 50.85396],
                [4.44968, 50.85591],
                [4.44599, 50.85992],
                [4.4253, 50.86615],
                [4.43183, 50.87628],
                [4.44007, 50.87845],
                [4.43106, 50.89014],
                [4.43595, 50.89502],
                [4.4296, 50.90103],
                [4.41655, 50.90757],
                [4.41543, 50.91342],
                [4.39578, 50.91407],
                [4.38462, 50.91093],
                [4.38119, 50.90319],
                [4.3726, 50.90032],
                [4.36213, 50.9033],
                [4.34857, 50.90341],
                [4.34025, 50.90411],
                [4.32892, 50.90249],
                [4.31647, 50.89605],
                [4.30634, 50.89274],
                [4.29004, 50.88982],
                [4.29149, 50.88495],
                [4.29553, 50.88262],
                [4.29561, 50.88094],
                [4.28274, 50.87227],
                [4.27699, 50.86713],
                [4.27802, 50.85911],
                [4.28042, 50.85721],
                [4.28094, 50.84215],
                [4.27193, 50.84036],
                [4.25467, 50.83695],
                [4.25107, 50.83288],
                [4.25227, 50.82697],
                [4.24343, 50.82182],
                [4.24403, 50.81548],
                [4.25519, 50.8151],
                [4.25802, 50.80935],
                [4.27218, 50.81011],
                [4.27579, 50.80696],
                [4.2854, 50.80506],
                [4.28901, 50.80691],
                [4.29802, 50.80593],
                [4.30282, 50.79709],
                [4.31458, 50.79454],
                [4.31621, 50.78624],
                [4.32952, 50.77381],
                [4.34205, 50.77164],
                [4.34522, 50.77337],
                [4.37853, 50.76811],
                [4.37973, 50.76382]
            ]
        ],
        "terms_text": "Realized by means of Brussels UrbIS®© - Distribution & Copyright CIRB",
        "best": true,
        "icon": "https://osmlab.github.io/editor-layer-index/sources/europe/be/URBIS2015aerialimagery.png"
    },
    {
        "id": "UrbisAdmFR",
        "name": "UrbisAdm FR",
        "type": "wms",
        "template": "https://geoservices-urbis.irisnet.be/geoserver/ows?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetMap&FORMAT=image/png&TRANSPARENT=true&LAYERS=urbisFR&WIDTH={width}&HEIGHT={height}&CRS={proj}&STYLES=&BBOX={bbox}",
        "projection": "EPSG:3857",
        "polygon": [
            [
                [4.4347, 50.77647],
                [4.45427, 50.78367],
                [4.4635, 50.78798],
                [4.48273, 50.79313],
                [4.44715, 50.80821],
                [4.44831, 50.81147],
                [4.45788, 50.81646],
                [4.45466, 50.81838],
                [4.4768, 50.82036],
                [4.46552, 50.83549],
                [4.46835, 50.83744],
                [4.46037, 50.85218],
                [4.44578, 50.85522],
                [4.44466, 50.85809],
                [4.43891, 50.86042],
                [4.43719, 50.85868],
                [4.42612, 50.86296],
                [4.42037, 50.86789],
                [4.42973, 50.87764],
                [4.43736, 50.87867],
                [4.42681, 50.89026],
                [4.43307, 50.89464],
                [4.42277, 50.90298],
                [4.41187, 50.90753],
                [4.41376, 50.91159],
                [4.4032, 50.91381],
                [4.38758, 50.9098],
                [4.37771, 50.89713],
                [4.36303, 50.90119],
                [4.34183, 50.9026],
                [4.33093, 50.90119],
                [4.31651, 50.89389],
                [4.3057, 50.8908],
                [4.29334, 50.88847],
                [4.29428, 50.88658],
                [4.29737, 50.8849],
                [4.29918, 50.87975],
                [4.28587, 50.87201],
                [4.27858, 50.86556],
                [4.28064, 50.85944],
                [4.28999, 50.85625],
                [4.28304, 50.85354],
                [4.28793, 50.84833],
                [4.28291, 50.8479],
                [4.28158, 50.83785],
                [4.27399, 50.8392],
                [4.27184, 50.8363],
                [4.25793, 50.83571],
                [4.2545, 50.83289],
                [4.25523, 50.82839],
                [4.2509, 50.82419],
                [4.24382, 50.81928],
                [4.2566, 50.81743],
                [4.25995, 50.81106],
                [4.27274, 50.81212],
                [4.2757, 50.81087],
                [4.27708, 50.80835],
                [4.28454, 50.80732],
                [4.29274, 50.80911],
                [4.2951, 50.80881],
                [4.30162, 50.81299],
                [4.3066, 50.81239],
                [4.30205, 50.80445],
                [4.30501, 50.7987],
                [4.31527, 50.79661],
                [4.31845, 50.79403],
                [4.3193, 50.78722],
                [4.32201, 50.7832],
                [4.33089, 50.7758],
                [4.3408, 50.77354],
                [4.34677, 50.77574],
                [4.3551, 50.77354],
                [4.36527, 50.77284],
                [4.38243, 50.76917],
                [4.38303, 50.76375],
                [4.43312, 50.77802],
                [4.4347, 50.77647]
            ]
        ],
        "terms_text": "Realized by means of Brussels UrbIS®© - Distribution & Copyright CIRB",
        "icon": "https://osmlab.github.io/editor-layer-index/sources/europe/be/URBIS2015aerialimagery.png"
    },
    {
        "id": "UrbisAdmNL",
        "name": "UrbisAdm NL",
        "type": "wms",
        "template": "https://geoservices-urbis.irisnet.be/geoserver/ows?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetMap&FORMAT=image/png&TRANSPARENT=true&LAYERS=urbisNL&WIDTH={width}&HEIGHT={height}&CRS={proj}&STYLES=&BBOX={bbox}",
        "projection": "EPSG:3857",
        "polygon": [
            [
                [4.4347, 50.77647],
                [4.45427, 50.78367],
                [4.4635, 50.78798],
                [4.48273, 50.79313],
                [4.44715, 50.80821],
                [4.44831, 50.81147],
                [4.45788, 50.81646],
                [4.45466, 50.81838],
                [4.4768, 50.82036],
                [4.46552, 50.83549],
                [4.46835, 50.83744],
                [4.46037, 50.85218],
                [4.44578, 50.85522],
                [4.44466, 50.85809],
                [4.43891, 50.86042],
                [4.43719, 50.85868],
                [4.42612, 50.86296],
                [4.42037, 50.86789],
                [4.42973, 50.87764],
                [4.43736, 50.87867],
                [4.42681, 50.89026],
                [4.43307, 50.89464],
                [4.42277, 50.90298],
                [4.41187, 50.90753],
                [4.41376, 50.91159],
                [4.4032, 50.91381],
                [4.38758, 50.9098],
                [4.37771, 50.89713],
                [4.36303, 50.90119],
                [4.34183, 50.9026],
                [4.33093, 50.90119],
                [4.31651, 50.89389],
                [4.3057, 50.8908],
                [4.29334, 50.88847],
                [4.29428, 50.88658],
                [4.29737, 50.8849],
                [4.29918, 50.87975],
                [4.28587, 50.87201],
                [4.27858, 50.86556],
                [4.28064, 50.85944],
                [4.28999, 50.85625],
                [4.28304, 50.85354],
                [4.28793, 50.84833],
                [4.28291, 50.8479],
                [4.28158, 50.83785],
                [4.27399, 50.8392],
                [4.27184, 50.8363],
                [4.25793, 50.83571],
                [4.2545, 50.83289],
                [4.25523, 50.82839],
                [4.2509, 50.82419],
                [4.24382, 50.81928],
                [4.2566, 50.81743],
                [4.25995, 50.81106],
                [4.27274, 50.81212],
                [4.2757, 50.81087],
                [4.27708, 50.80835],
                [4.28454, 50.80732],
                [4.29274, 50.80911],
                [4.2951, 50.80881],
                [4.30162, 50.81299],
                [4.3066, 50.81239],
                [4.30205, 50.80445],
                [4.30501, 50.7987],
                [4.31527, 50.79661],
                [4.31845, 50.79403],
                [4.3193, 50.78722],
                [4.32201, 50.7832],
                [4.33089, 50.7758],
                [4.3408, 50.77354],
                [4.34677, 50.77574],
                [4.3551, 50.77354],
                [4.36527, 50.77284],
                [4.38243, 50.76917],
                [4.38303, 50.76375],
                [4.43312, 50.77802],
                [4.4347, 50.77647]
            ]
        ],
        "terms_text": "Realized by means of Brussels UrbIS®© - Distribution & Copyright CIRB",
        "icon": "https://osmlab.github.io/editor-layer-index/sources/europe/be/URBIS2015aerialimagery.png"
    },
    {
        "id": "URBISfr2013",
        "name": "URBISfr numerical imagery (2013)",
        "type": "wms",
        "template": "https://gis.irisnet.be/arcgis/rest/services/basemap/urbisFR/MapServer/export?f=image&format=png8&transparent=False&SRS={proj}&bboxSR=3857&imageSR=3857&bbox={bbox}&size={width},{height}",
        "projection": "EPSG:3857",
        "endDate": "2013-01-01T00:00:00.000Z",
        "startDate": "2013-01-01T00:00:00.000Z",
        "polygon": [
            [
                [4.4347, 50.77647],
                [4.45427, 50.78367],
                [4.4635, 50.78798],
                [4.48273, 50.79313],
                [4.44715, 50.80821],
                [4.44831, 50.81147],
                [4.45788, 50.81646],
                [4.45466, 50.81838],
                [4.4768, 50.82036],
                [4.46552, 50.83549],
                [4.46835, 50.83744],
                [4.46037, 50.85218],
                [4.44578, 50.85522],
                [4.44466, 50.85809],
                [4.43891, 50.86042],
                [4.43719, 50.85868],
                [4.42612, 50.86296],
                [4.42037, 50.86789],
                [4.42973, 50.87764],
                [4.43736, 50.87867],
                [4.42681, 50.89026],
                [4.43307, 50.89464],
                [4.42277, 50.90298],
                [4.41187, 50.90753],
                [4.41376, 50.91159],
                [4.4032, 50.91381],
                [4.38758, 50.9098],
                [4.37771, 50.89713],
                [4.36303, 50.90119],
                [4.34183, 50.9026],
                [4.33093, 50.90119],
                [4.31651, 50.89389],
                [4.3057, 50.8908],
                [4.29334, 50.88847],
                [4.29428, 50.88658],
                [4.29737, 50.8849],
                [4.29918, 50.87975],
                [4.28587, 50.87201],
                [4.27858, 50.86556],
                [4.28064, 50.85944],
                [4.28999, 50.85625],
                [4.28304, 50.85354],
                [4.28793, 50.84833],
                [4.28291, 50.8479],
                [4.28158, 50.83785],
                [4.27399, 50.8392],
                [4.27184, 50.8363],
                [4.25793, 50.83571],
                [4.2545, 50.83289],
                [4.25523, 50.82839],
                [4.2509, 50.82419],
                [4.24382, 50.81928],
                [4.2566, 50.81743],
                [4.25995, 50.81106],
                [4.27274, 50.81212],
                [4.2757, 50.81087],
                [4.27708, 50.80835],
                [4.28454, 50.80732],
                [4.29274, 50.80911],
                [4.2951, 50.80881],
                [4.30162, 50.81299],
                [4.3066, 50.81239],
                [4.30205, 50.80445],
                [4.30501, 50.7987],
                [4.31527, 50.79661],
                [4.31845, 50.79403],
                [4.3193, 50.78722],
                [4.32201, 50.7832],
                [4.33089, 50.7758],
                [4.3408, 50.77354],
                [4.34677, 50.77574],
                [4.3551, 50.77354],
                [4.36527, 50.77284],
                [4.38243, 50.76917],
                [4.38303, 50.76375],
                [4.43312, 50.77802],
                [4.4347, 50.77647]
            ]
        ],
        "terms_text": "Realized by means of Brussels UrbIS®© - Distribution & Copyright CIRB",
        "icon": "https://osmlab.github.io/editor-layer-index/sources/europe/be/URBIS2015aerialimagery.png"
    },
    {
        "id": "URBISnl2013",
        "name": "URBISnl numerical imagery (2013)",
        "type": "wms",
        "template": "https://gis.irisnet.be/arcgis/rest/services/basemap/urbisNL/MapServer/export?f=image&format=png8&transparent=False&SRS={proj}&bboxSR=3857&imageSR=3857&bbox={bbox}&size={width},{height}",
        "projection": "EPSG:3857",
        "endDate": "2013-01-01T00:00:00.000Z",
        "startDate": "2013-01-01T00:00:00.000Z",
        "polygon": [
            [
                [4.4347, 50.77647],
                [4.45427, 50.78367],
                [4.4635, 50.78798],
                [4.48273, 50.79313],
                [4.44715, 50.80821],
                [4.44831, 50.81147],
                [4.45788, 50.81646],
                [4.45466, 50.81838],
                [4.4768, 50.82036],
                [4.46552, 50.83549],
                [4.46835, 50.83744],
                [4.46037, 50.85218],
                [4.44578, 50.85522],
                [4.44466, 50.85809],
                [4.43891, 50.86042],
                [4.43719, 50.85868],
                [4.42612, 50.86296],
                [4.42037, 50.86789],
                [4.42973, 50.87764],
                [4.43736, 50.87867],
                [4.42681, 50.89026],
                [4.43307, 50.89464],
                [4.42277, 50.90298],
                [4.41187, 50.90753],
                [4.41376, 50.91159],
                [4.4032, 50.91381],
                [4.38758, 50.9098],
                [4.37771, 50.89713],
                [4.36303, 50.90119],
                [4.34183, 50.9026],
                [4.33093, 50.90119],
                [4.31651, 50.89389],
                [4.3057, 50.8908],
                [4.29334, 50.88847],
                [4.29428, 50.88658],
                [4.29737, 50.8849],
                [4.29918, 50.87975],
                [4.28587, 50.87201],
                [4.27858, 50.86556],
                [4.28064, 50.85944],
                [4.28999, 50.85625],
                [4.28304, 50.85354],
                [4.28793, 50.84833],
                [4.28291, 50.8479],
                [4.28158, 50.83785],
                [4.27399, 50.8392],
                [4.27184, 50.8363],
                [4.25793, 50.83571],
                [4.2545, 50.83289],
                [4.25523, 50.82839],
                [4.2509, 50.82419],
                [4.24382, 50.81928],
                [4.2566, 50.81743],
                [4.25995, 50.81106],
                [4.27274, 50.81212],
                [4.2757, 50.81087],
                [4.27708, 50.80835],
                [4.28454, 50.80732],
                [4.29274, 50.80911],
                [4.2951, 50.80881],
                [4.30162, 50.81299],
                [4.3066, 50.81239],
                [4.30205, 50.80445],
                [4.30501, 50.7987],
                [4.31527, 50.79661],
                [4.31845, 50.79403],
                [4.3193, 50.78722],
                [4.32201, 50.7832],
                [4.33089, 50.7758],
                [4.3408, 50.77354],
                [4.34677, 50.77574],
                [4.3551, 50.77354],
                [4.36527, 50.77284],
                [4.38243, 50.76917],
                [4.38303, 50.76375],
                [4.43312, 50.77802],
                [4.4347, 50.77647]
            ]
        ],
        "terms_text": "Realized by means of Brussels UrbIS®© - Distribution & Copyright CIRB",
        "icon": "https://osmlab.github.io/editor-layer-index/sources/europe/be/URBIS2015aerialimagery.png"
    },
    {
        id: "maptiler-sattelite",
        name: "Maptiler Satelite Global",
        type: "tms",
        template: "https://api.maptiler.com/tiles/satellite-v2/{z}/{x}/{y}.jpg?key=OZUCIh4RNx38vXF8gF4H",
        "zoomExtent": [0, 20],
    }
];
